import styled from 'styled-components'

export const PaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  svg {
    width: 20px;
    height: 20px;
  }
`
